import React from 'react';
const Storage = () => {
  return(
<>
    <div className="bg">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
            <h1 className="fs-1 text-center pt-5">Storage Hosting</h1>
            <p className="text-center">Store images, videos, backups and more! Interserver storage plans are perfect for archiving data publicly or privately. Storage packages come with 200GB to 20TB of storage. Upgrade or downgrade anytime. Easy to manage control panel powered by DirectAdmin. User level access, with large storage as well as ready to go:</p>
            <ul>
                <li>* FTP over TLS</li>
                <li>* SSH (sftp/scp/rsync)</li>
                <li>* Litespeed Webserver</li>
                <li>* MySQL compatible database</li>
                <li>* DirectAdmin control panel</li>
                <li>* Mirrored RAID-Z2 over the ZFS filesystem</li>
                <li>* API aware object storage now in beta</li>
                <li>* Storage hosting is a shared hosting product for large storage and is not a vps with root access. Please find more information for Storage VPS and alternative product if root access is a requirement</li>
                <li>* Please note storage backups have no backups and only offer redundancy against harddrive failures over a mirrored RAIDZ-2 ZFS file systerm</li>
            </ul>
            <div className="row d-flex justify-content-center">
                <h1 className="fs-1 text-center pt-5">Choose your Plan</h1>
                <table className="mt-5 border-table">
                    <tr className="color text-center">
                        <th>&nbsp;</th>
                        <th>ST 100</th>
                        <th>ST 200</th>
                        <th>ST 300</th>
                        <th>ST 400</th>
                        <th>ST 500</th>
                        <th>ST 600</th>
                    </tr>
                    <tr>
                        <th>Space</th>
                        <td>200 GB</td>
                        <td>1 TB</td>
                        <td>2 TB</td>
                        <td>4 TB</td>
                        <td>10 TB</td>
                        <td>20 TB</td>
                    </tr>
                    <tr>
                        <th>Transfer</th>
                        <td>1 TB</td>
                        <td>2 TB</td>
                        <td>5 TB</td>
                        <td>10 TB</td>
                        <td>15 TB</td>
                        <td>20 TB</td>
                    </tr>
                    <tr>
                        <th>Transfer</th>
                        <td>1 TB</td>
                        <td>2 TB</td>
                        <td>5 TB</td>
                        <td>10 TB</td>
                        <td>15 TB</td>
                        <td>20 TB</td>
                    </tr>
                    <tr>
                        <th>Domains</th>
                        <td>5</td>
                        <td>10</td>
                        <td>20</td>
                        <td>30</td>
                        <td>50</td>
                        <td>60</td>
                    </tr>
                    <tr>
                        <th>Sub Domains</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>Unlimited Users</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>HTTP/HTTPS</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>FTP</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>SFTP</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>RSYNC</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>File Manager</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>MYSQL</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>PHP</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>CGI</th>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                    </tr>
                    <tr>
                        <th>Control Panel</th>
                        <td>DirectAdmin</td>
                        <td>DirectAdmin</td>
                        <td>DirectAdmin</td>
                        <td>DirectAdmin</td>
                        <td>DirectAdmin</td>
                        <td>DirectAdmin</td>
                    </tr>
                    <tr>
                        <th>Monthly</th>
                        <td>$3</td>
                        <td>$5</td>
                        <td>$8</td>
                        <td>$10</td>
                        <td>$25</td>
                        <td>$42</td>
                    </tr>
                </table>
            </div>
           <div className="row d-flex justify-content-center">
                <div className="col-md-6 text-center">
                    <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5 w-50  "><a href="Contactform" className='p-5'>Contact Us</a></button>
                </div>
           </div>
            
            <div className="row mt-5">
                <div className="col-md-4">
                    <img src="https://www.interserver.net/storage/assets/images/mig.png" className="w-100"/>
                </div>
                <div className="col-md-8 mt-5">
                    <p className="fs-2">Designed to Backup Your Files</p>
                    <p>Stored hosting was designed initially for storing file backups but has expanded from this. We all know the importance of backups by now. Use our Storage Hosting Service to backup your files with FTP, SFTP, or rsync. Our Storage Hosting packages are a very flexible and cost-effective way to store your data.</p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-8 mt-5">
                    <p className="fs-2">Built-In Web Server</p>
                    <p>Serve you files to users with the built-in web server. Use or service for streaming videos, photos, files and everything else in between. Powered by the Litespeed web server for fast content delivery.</p>
                </div>
                <div className="col-md-4">
                    <img src="https://www.interserver.net/storage/assets/images/feeweb.png" className="w-100"/>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-4">
                    <img src="https://www.interserver.net/storage/assets/images/owncloud.png" className="w-100"/>
                </div>
                <div className="col-md-8 mt-5">
                    <p className="fs-2">OwnCloud</p>
                    <p>OwnCloud can be installed on our storage hosting packages over Softaculous auto installer. With OwnCloud you can Store data securely and access it from any location and device. Work together and manage workflows. For more information on OwnCloud visit owncloud.org.</p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-8 mt-5">
                    <p className="fs-2">Easy to use Control Panel</p>
                    <p>Easily add domain names, subdomains, FTP accounts, MySql databases and more in our easy to use control panel powered by DirectAdmin. Please note: Email is not offered on storage hosting. Consider adding Mail.Baby through the mailsection of my.interserver.net for SMTP support, or add standard shared hosting for POP/IMAP and SMTP support.</p>
                </div>
                <div className="col-md-4 mt-5">
                    <img src="https://www.interserver.net/storage/assets/images/cp.png" className="w-100"/>
                </div>
            </div>
        </div>
    </div>
</>
    );
};
 
export default Storage;